<template>
  <v-app>
    <v-app-bar app color="indigo" dark>
      <h1 class="d-flex align-center">
        <v-icon x-large>track_changes</v-icon>
        <span class="font-italic">TRACEROUTE.TO</span>
      </h1>

      <v-spacer></v-spacer>

<!--      <v-btn href="Account" text>-->
<!--        <span class="mr-2">Account</span>-->
<!--        <v-icon>account_box</v-icon>-->
<!--      </v-btn>-->
    </v-app-bar>
    <v-main>
      <v-container>
        <!--<v-row align="center" justify="center">
                <v-col cols="8" sm="10" md="10" lg="8">
                    <v-alert color="pink"
                             dark
                             border="top"
                             icon="save_alt"
                             dismissible
                             transition="scale-transition">
                        This tool is funded by adverts. We use cookies to personalise
                        content and ads, to provide social media features and to analyse our
                        traffic. We also share information about your use of our site with
                        our social media, advertising and analytics partners who may combine
                        it with other information that you’ve provided to them or that
                        they’ve collected from your use of their services.
                    </v-alert>
                </v-col>
            </v-row>-->
<!--        <v-row align="center" justify="center">-->
<!--          <v-col cols="12" xs="12" sm="12" md="10" lg="8">-->
<!--            <v-alert-->
<!--              color="green"-->
<!--              dark-->
<!--              border="top"-->
<!--              icon="info"-->
<!--              transition="scale-transition"-->
<!--            >-->
<!--              <h2>Visual Traceroute to a domain name or IP address.</h2>-->
<!--              <p>-->
<!--                Use our tool to visualise the route traffic takes between two points on the internet.-->
<!--                One of our servers will be the starting point and you will choose the target server.-->
<!--                </p>-->
<!--              <p>This can help you diagnose network issues and bottlenecks, and see who's network is causing the issues.-->
<!--              </p>-->
<!--              <p>-->
<!--                You can use this information to report issues to your web hosting supplier, so they can see if the issue is withing their control.-->
<!--              </p>-->
<!--              <p>In the near future we will be utilise Google Cloud services to provide multiple sources to check your routes.</p>-->
<!--              <p>This will be useful for web hosting companies to help visualise issues or potential issues with reaching networks.</p>-->
<!--              <p>You can use this tool to monitor web hosting companies to see how quickly their services respond, to see if they will be a good fit your website.</p>-->
<!--              <v-btn href="#more-details">More details on traceroute</v-btn>-->
<!--            </v-alert>-->
<!--          </v-col>-->
<!--        </v-row>-->

        <router-view />

        <v-row align="center" justify="center" id="more-details">
          <v-col cols="10" sm="10" md="10" lg="8">
            <v-alert
              color="blue"
              dark
              border="top"
              icon="info"
              transition="scale-transition"
            >
              <p>This tool checks the route to the domain or IP address you
              supplied. The route is from our server to the endpoint and the
              time taken is shown. Sometimes, a timeout is shown - this might
              mean that point in the network either ignore ping requests, or it
                is having trouble.</p>
              <p></p>
            </v-alert>
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <v-footer dark padless>
      <v-card
        flat
        tile
        class="indigo lighten-1 white--text text-center"
        width="100%"
      >
        <v-card-text class="white--text">
          Currently being developed. Road map includes: visual trace on map,
          continuous monitoring, and more!
        </v-card-text>

        <v-divider></v-divider>

        <v-card-text class="white--text">
          <v-btn
            text
            large
            color="white"
            href="https://dr.xoozoo.com"
            target="_blank"
          >
            &copy; {{ new Date().getFullYear() }} — powered by dr.xoozoo.com
          </v-btn>
        </v-card-text>
      </v-card>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: "App",

  components: {},

  data: () => ({
    //
  }),
};
</script>
